const companyTypesMaster = [
  {
    child: {
      services: [
        { id: 29, service: 'Financing & Investment Services' },
        { id: 1, service: 'Financing Services' },
      ],
      subtypes: [
        { id: 1, subtype: 'Film Funds' },
        { id: 31, subtype: 'Financing & Investment Services' },
      ],
    },
    id: 1,
    type: 'Financing',
  },
  {
    child: {
      services: [{ id: 30, service: 'Legal Services' }],
      subtypes: [{ id: 33, subtype: 'Law Firm' }],
    },
    id: 2,
    type: 'Legal',
  },
  {
    child: {
      services: [
        { id: 40, service: 'Management Services' },
        { id: 2, service: 'Talent Agency' },
      ],
      subtypes: [
        { id: 32, subtype: 'Management Services' },
        { id: 2, subtype: 'Talent Agency' },
      ],
    },
    id: 3,
    type: 'Talent Management',
  },
  {
    child: { services: [{ id: 3, service: 'Casting' }], subtypes: [{ id: 3, subtype: 'Casting' }] },
    id: 4,
    type: 'Pre-Production',
  },
  {
    child: { services: [{ id: 31, service: 'Production' }], subtypes: [] },
    id: 5,
    type: 'Production House',
  },
  {
    child: {
      services: [
        { id: 15, service: 'Accommodation & Transport Services' },
        { id: 4, service: 'Art Department Services' },
        { id: 6, service: 'Audio, Film & Video Stock Provider' },
        { id: 13, service: 'Camera Equipment Services' },
        { id: 5, service: 'Costume & Wardrobe Services' },
        { id: 7, service: 'Grip Equipment Services' },
        { id: 8, service: 'Lighting Equipment Services' },
        { id: 9, service: 'Location Facilities & Services' },
        { id: 10, service: 'Office Services' },
        { id: 11, service: 'Production Equipment & Services' },
        { id: 14, service: 'Security Services' },
        { id: 12, service: 'Sound Equipment Services' },
        { id: 17, service: 'Sound Stage Provider' },
        { id: 16, service: 'Special Effects' },
      ],
      subtypes: [
        { id: 15, subtype: 'Accommodation & Transport Services' },
        { id: 4, subtype: 'Art Department Services' },
        { id: 6, subtype: 'Audio, Film & Video Stock Provider' },
        { id: 13, subtype: 'Camera Equipment Services' },
        { id: 5, subtype: 'Costume & Wardrobe Services' },
        { id: 7, subtype: 'Grip Equipment Services' },
        { id: 8, subtype: 'Lighting Equipment Services' },
        { id: 9, subtype: 'Location Facilities & Services' },
        { id: 10, subtype: 'Office Services' },
        { id: 11, subtype: 'Production Equipment & Services' },
        { id: 14, subtype: 'Security Services' },
        { id: 12, subtype: 'Sound Equipment Services' },
        { id: 17, subtype: 'Sound Stage Provider' },
        { id: 16, subtype: 'Special Effects' },
      ],
    },
    id: 6,
    type: 'Production Services',
  },
  {
    child: {
      services: [
        { id: 18, service: 'Creative Post-Production Services' },
        { id: 38, service: 'Post-Production Facilities' },
        { id: 20, service: 'Post-Production Facilities & Services' },
        { id: 19, service: 'Visual Effects' },
      ],
      subtypes: [
        { id: 18, subtype: 'Creative Post-Production' },
        { id: 20, subtype: 'Post-Production Facilities' },
        { id: 19, subtype: 'Visual Effects' },
      ],
    },
    id: 7,
    type: 'Post-Production',
  },
  {
    child: {
      services: [
        { id: 21, service: 'Dubbing Services' },
        { id: 24, service: 'Language Services' },
        { id: 22, service: 'Subtitling Services' },
        { id: 23, service: 'Voice Over Services' },
      ],
      subtypes: [
        { id: 21, subtype: 'Dubbing' },
        { id: 24, subtype: 'Language Services Provider (LSP)' },
        { id: 22, subtype: 'Subtitling' },
        { id: 23, subtype: 'Voice Over' },
      ],
    },
    id: 8,
    type: 'Localisation',
  },
  {
    child: {
      services: [
        { id: 39, service: 'Marketing & Promotion Services' },
        { id: 25, service: 'Public Relations' },
      ],
      subtypes: [
        { id: 26, subtype: 'Advertising & Media' },
        { id: 25, subtype: 'Publicist' },
      ],
    },
    id: 9,
    type: 'Marketing & Promotions',
  },
  {
    child: {
      services: [
        { id: 26, service: 'Approvals & Certifications' },
        { id: 27, service: 'Regulation & Standards' },
      ],
      subtypes: [
        { id: 27, subtype: 'Film Commission' },
        { id: 28, subtype: 'Govt & Industry Body' },
        { id: 29, subtype: 'Unions & Guilds' },
      ],
    },
    id: 10,
    type: 'Association/Industry Body',
  },
  {
    child: {
      services: [{ id: 28, service: 'Sales' }],
      subtypes: [{ id: 30, subtype: 'International Sales Agent' }],
    },
    id: 11,
    type: 'Sales Agent',
  },
  {
    child: { services: [{ id: 32, service: 'Distribution' }], subtypes: [] },
    id: 12,
    type: 'Distribution Company',
  },
  {
    child: { services: [{ id: 33, service: 'Content Delivery Services' }], subtypes: [] },
    id: 13,
    type: 'Packaging & Delivery',
  },
  {
    child: { services: [{ id: 34, service: 'Theatrical Distribution' }], subtypes: [] },
    id: 14,
    type: 'Theatre Chain',
  },
  {
    child: { services: [{ id: 35, service: 'Streaming Services' }], subtypes: [] },
    id: 15,
    type: 'OTT Provider',
  },
  {
    child: { services: [{ id: 36, service: 'Broadcast Services' }], subtypes: [] },
    id: 16,
    type: 'Broadcaster',
  },
  {
    child: { services: [{ id: 37, service: 'Operator Services' }], subtypes: [] },
    id: 17,
    type: 'Operator/MVPD/Telco',
  },
  { child: { services: [], subtypes: [] }, id: 197, type: 'Non-Media Client' },
  { child: { services: [], subtypes: [] }, id: 198, type: 'Corporation/Holding Co./Group Co.' },

  { child: { services: [], subtypes: [] }, id: 199, type: 'Publishing' },
  { child: { services: [], subtypes: [] }, id: 200, type: 'Content Aggregator' },
//  { child: { services: [], subtypes: [] }, id: 201, type: 'Software & Tech Solutions' },
  { child: { services: [], subtypes: [] }, id: 202, type: 'Creative Services' },
  { child: { services: [], subtypes: [] }, id: 203, type: 'Streaming Devices' },
  { child: { services: [], subtypes: [] }, id: 204, type: 'Gaming & Gaming Consoles' },
  { child: { services: [], subtypes: [] }, id: 210, type: 'Non M&E Sector' },
  { child: { services: [], subtypes: [] }, id: 209, type: 'App/SaaS/Product Development' },
  { child: { services: [], subtypes: [] }, id: 208, type: 'App/SaaS/Product' },
  { child: { services: [], subtypes: [] }, id: 207, type: 'Web3 Company' },
  { child: { services: [], subtypes: [] }, id: 211, type: 'Digital Channel' },
  // { child: { services: [], subtypes: [] }, id: 18, type: 'Others' },
  // { child: { services: [], subtypes: [] }, id: 19, type: 'Subtitling, Titles & Closed Captions' },
  // { child: { services: [], subtypes: [] }, id: 20, type: 'Craft Services' },
  // { child: { services: [], subtypes: [] }, id: 21, type: 'Video Stock Footage' },
  // { child: { services: [], subtypes: [] }, id: 22, type: 'Color Processing' },
  // { child: { services: [], subtypes: [] }, id: 23, type: 'Video Camera Equipment' },
  // { child: { services: [], subtypes: [] }, id: 24, type: '5.1 Stereo Surround' },
  // { child: { services: [], subtypes: [] }, id: 25, type: 'Pre Production Services' },
  // { child: { services: [], subtypes: [] }, id: 26, type: 'Stills Photographers' },
  // { child: { services: [], subtypes: [] }, id: 27, type: 'Animal Wranglers' },
  // { child: { services: [], subtypes: [] }, id: 28, type: 'Remote Heads' },
  // { child: { services: [], subtypes: [] }, id: 29, type: 'Sound Recording' },
  // { child: { services: [], subtypes: [] }, id: 30, type: 'Video Assist Equipment' },
  // { child: { services: [], subtypes: [] }, id: 31, type: 'Stills Photography Production Services' },
  // { child: { services: [], subtypes: [] }, id: 32, type: 'Authors' },
  // { child: { services: [], subtypes: [] }, id: 33, type: 'Web Design' },
  // { child: { services: [], subtypes: [] }, id: 34, type: 'Digital Intermediate Services' },
  // { child: { services: [], subtypes: [] }, id: 35, type: 'Production Insurance' },
  // { child: { services: [], subtypes: [] }, id: 36, type: 'Transportation Services' },
  // { child: { services: [], subtypes: [] }, id: 37, type: 'Prop Vehicles' },
  // { child: { services: [], subtypes: [] }, id: 38, type: 'Editing Services' },
  // { child: { services: [], subtypes: [] }, id: 39, type: 'Animal Action Monitoring' },
  // { child: { services: [], subtypes: [] }, id: 40, type: 'Color Correction / Color Grading' },
  // { child: { services: [], subtypes: [] }, id: 41, type: 'Archival Footage' },
  // { child: { services: [], subtypes: [] }, id: 42, type: 'Studios / Soundstages' },
  // { child: { services: [], subtypes: [] }, id: 43, type: 'Art Department Services' },
  // { child: { services: [], subtypes: [] }, id: 44, type: 'Funding' },
  // { child: { services: [], subtypes: [] }, id: 45, type: 'Dailies' },
  // { child: { services: [], subtypes: [] }, id: 46, type: 'Audio Post Production' },
  // { child: { services: [], subtypes: [] }, id: 47, type: 'Stabilized Remote Camera Systems' },
  // { child: { services: [], subtypes: [] }, id: 48, type: 'Technical Support' },
  // { child: { services: [], subtypes: [] }, id: 49, type: 'Creative Consultancy Services' },
  // { child: { services: [], subtypes: [] }, id: 50, type: 'Storyboards' },
  // { child: { services: [], subtypes: [] }, id: 51, type: 'Permit Services' },
  // { child: { services: [], subtypes: [] }, id: 52, type: 'Walla Group' },
  // { child: { services: [], subtypes: [] }, id: 53, type: 'Compositing' },
  // { child: { services: [], subtypes: [] }, id: 54, type: 'Voice Casting' },
  // { child: { services: [], subtypes: [] }, id: 55, type: 'Online Editing' },
  // { child: { services: [], subtypes: [] }, id: 56, type: 'Approval and Certification Services' },
  // {
  //   child: { services: [], subtypes: [] },
  //   id: 57,
  //   type: 'Blu-Ray / DVD / USB Services - Duplication, Replication, Authoring',
  // },
  // { child: { services: [], subtypes: [] }, id: 58, type: 'Animals Trainers' },
  // { child: { services: [], subtypes: [] }, id: 59, type: 'Catering Services' },
  // {
  //   child: { services: [], subtypes: [] },
  //   id: 60,
  //   type: 'Marketing , Promotion & Advertising Services',
  // },
  // { child: { services: [], subtypes: [] }, id: 61, type: 'Stabilized Camera Systems' },
  // { child: { services: [], subtypes: [] }, id: 62, type: 'Cutting Room' },
  // { child: { services: [], subtypes: [] }, id: 63, type: 'Stills Photography' },
  // { child: { services: [], subtypes: [] }, id: 64, type: 'Digital Mastering' },
  // { child: { services: [], subtypes: [] }, id: 65, type: 'Post Production Services' },
  // { child: { services: [], subtypes: [] }, id: 66, type: 'Underwater Camera Equipment' },
  // { child: { services: [], subtypes: [] }, id: 67, type: 'Post Production, Animation' },
  // { child: { services: [], subtypes: [] }, id: 68, type: 'Grip & Lighting Equipment' },
  // { child: { services: [], subtypes: [] }, id: 69, type: 'Matte Painting' },
  // { child: { services: [], subtypes: [] }, id: 70, type: 'Telecine Transfers' },
  // { child: { services: [], subtypes: [] }, id: 71, type: 'Casting Services' },
  // { child: { services: [], subtypes: [] }, id: 72, type: 'Dubbing Services' },
  // { child: { services: [], subtypes: [] }, id: 73, type: 'ADR / Automated Dialogue Replacement' },
  // { child: { services: [], subtypes: [] }, id: 74, type: 'Lighting Equipment' },
  // { child: { services: [], subtypes: [] }, id: 75, type: 'Production Facilities' },
  // { child: { services: [], subtypes: [] }, id: 76, type: 'Corporate Credit Services' },
  // { child: { services: [], subtypes: [] }, id: 77, type: 'Underwater Photography Equipment' },
  // { child: { services: [], subtypes: [] }, id: 78, type: 'Extras Casting Services' },
  // { child: { services: [], subtypes: [] }, id: 79, type: 'Cloud Computing & Rendering Services' },
  // { child: { services: [], subtypes: [] }, id: 80, type: 'Camera Equipment & Lenses' },
  // { child: { services: [], subtypes: [] }, id: 81, type: 'Credits, Titles & Graphics' },
  // { child: { services: [], subtypes: [] }, id: 82, type: 'Dollies' },
  // { child: { services: [], subtypes: [] }, id: 83, type: 'Health & Safety' },
  // { child: { services: [], subtypes: [] }, id: 84, type: 'Production' },
  // { child: { services: [], subtypes: [] }, id: 85, type: 'Grip Equipment' },
  // { child: { services: [], subtypes: [] }, id: 86, type: 'Digital Services' },
  // { child: { services: [], subtypes: [] }, id: 87, type: 'Camera & Lighting Equipment' },
  // { child: { services: [], subtypes: [] }, id: 88, type: 'Visual Effects' },
  // { child: { services: [], subtypes: [] }, id: 89, type: 'Editing Equipment' },
  // { child: { services: [], subtypes: [] }, id: 90, type: 'Security Services' },
  // { child: { services: [], subtypes: [] }, id: 91, type: 'Production Equipment & Services' },
  // { child: { services: [], subtypes: [] }, id: 92, type: 'Transcription Services' },
  // { child: { services: [], subtypes: [] }, id: 93, type: 'Film / Video Transfers' },
  // { child: { services: [], subtypes: [] }, id: 95, type: 'Wireless Camera System' },
  // { child: { services: [], subtypes: [] }, id: 96, type: 'Still Images' },
  // { child: { services: [], subtypes: [] }, id: 97, type: 'Negative Services' },
  // { child: { services: [], subtypes: [] }, id: 98, type: 'Sound Effects' },
  // { child: { services: [], subtypes: [] }, id: 99, type: 'Travel Agents' },
  // { child: { services: [], subtypes: [] }, id: 100, type: 'Public Relations / Unit Publicists' },
  // { child: { services: [], subtypes: [] }, id: 101, type: '3D Camera' },
  // { child: { services: [], subtypes: [] }, id: 102, type: 'Promos & Trailers' },
  // { child: { services: [], subtypes: [] }, id: 103, type: 'Location Services & Facilities' },
  // { child: { services: [], subtypes: [] }, id: 104, type: 'Banking Services' },
  // { child: { services: [], subtypes: [] }, id: 105, type: 'Legal Services' },
  // { child: { services: [], subtypes: [] }, id: 106, type: 'Office & Payroll Services' },
  // { child: { services: [], subtypes: [] }, id: 107, type: 'Post Production Facilities' },
  // {
  //   child: { services: [], subtypes: [] },
  //   id: 108,
  //   type: 'Underwater Filming Production Equipment',
  // },
  // { child: { services: [], subtypes: [] }, id: 109, type: 'Stills Photography Equipment' },
  // { child: { services: [], subtypes: [] }, id: 110, type: 'Digital Post Production' },
  // { child: { services: [], subtypes: [] }, id: 111, type: 'Animation Production Companies' },
  // { child: { services: [], subtypes: [] }, id: 112, type: 'Audio Mixing' },
  // { child: { services: [], subtypes: [] }, id: 113, type: 'Animal Services' },
  // { child: { services: [], subtypes: [] }, id: 114, type: 'Recording Studios' },
  // { child: { services: [], subtypes: [] }, id: 115, type: 'Editing Facilities' },
  // { child: { services: [], subtypes: [] }, id: 116, type: 'Sound Services' },
  // { child: { services: [], subtypes: [] }, id: 117, type: 'Technical Advisors' },
  // { child: { services: [], subtypes: [] }, id: 118, type: 'Electric Equipment' },
  // { child: { services: [], subtypes: [] }, id: 119, type: 'Remote Camera Systems' },
  // {
  //   child: { services: [], subtypes: [] },
  //   id: 120,
  //   type: 'HD / UHD / 4K Post Production Editing Services',
  // },
  // { child: { services: [], subtypes: [] }, id: 121, type: 'VTR Decks / Players / Recorders' },
  // { child: { services: [], subtypes: [] }, id: 122, type: 'Sound Mixing' },
  // { child: { services: [], subtypes: [] }, id: 123, type: 'Digital Compositing' },
  // { child: { services: [], subtypes: [] }, id: 124, type: 'Cranes & Dollies' },
  // { child: { services: [], subtypes: [] }, id: 125, type: 'Aerial Filming' },
  // { child: { services: [], subtypes: [] }, id: 126, type: 'Translation Services' },
  // { child: { services: [], subtypes: [] }, id: 127, type: 'Accommodation Services' },
  // { child: { services: [], subtypes: [] }, id: 128, type: 'Cherry Picker Rental' },
  // { child: { services: [], subtypes: [] }, id: 129, type: 'Film / 16mm / 35mm Camera' },
  // { child: { services: [], subtypes: [] }, id: 130, type: 'Auditing' },
  // { child: { services: [], subtypes: [] }, id: 131, type: 'Prop Vehicle Rental' },
  // { child: { services: [], subtypes: [] }, id: 132, type: 'Stills Footage' },
  // { child: { services: [], subtypes: [] }, id: 133, type: 'Grip & Electrical Equipment' },
  // { child: { services: [], subtypes: [] }, id: 134, type: 'Branding Activities' },
  // { child: { services: [], subtypes: [] }, id: 135, type: 'Hair & Make-Up Services' },
  // { child: { services: [], subtypes: [] }, id: 136, type: 'Research Services' },
  // { child: { services: [], subtypes: [] }, id: 137, type: 'Sound Design' },
  // { child: { services: [], subtypes: [] }, id: 138, type: 'Product Placement' },
  // { child: { services: [], subtypes: [] }, id: 139, type: 'Foley Stages' },
  // { child: { services: [], subtypes: [] }, id: 140, type: 'Sound Editing' },
  // { child: { services: [], subtypes: [] }, id: 141, type: 'Filming Cars & Tracking Vehicles' },
  // { child: { services: [], subtypes: [] }, id: 142, type: 'Sound Equipment' },
  // { child: { services: [], subtypes: [] }, id: 143, type: 'Costume & Wardrobe' },
  // { child: { services: [], subtypes: [] }, id: 144, type: 'Finance & Insurance' },
  // { child: { services: [], subtypes: [] }, id: 145, type: 'Management & Consultancy' },
  // { child: { services: [], subtypes: [] }, id: 146, type: '3D Content Creation' },
  // { child: { services: [], subtypes: [] }, id: 147, type: 'Camera & Grip Equipment Rental' },
  // { child: { services: [], subtypes: [] }, id: 148, type: 'Color & Prints' },
  // { child: { services: [], subtypes: [] }, id: 149, type: 'Audio Visual Services' },
  // {
  //   child: { services: [], subtypes: [] },
  //   id: 150,
  //   type: 'Soundtrack Production / Jingles Production',
  // },
  // { child: { services: [], subtypes: [] }, id: 151, type: 'Aerial Coordinators' },
  // { child: { services: [], subtypes: [] }, id: 152, type: 'Stock Footage' },
  // { child: { services: [], subtypes: [] }, id: 153, type: '2D & 3D Animation' },
  // { child: { services: [], subtypes: [] }, id: 154, type: 'Aerial Camera Mount Rental' },
  // { child: { services: [], subtypes: [] }, id: 155, type: 'Video Post Production' },
  // { child: { services: [], subtypes: [] }, id: 156, type: 'Digital Media Services' },
  // { child: { services: [], subtypes: [] }, id: 157, type: '2K/4K Resolution FIlming' },
  // { child: { services: [], subtypes: [] }, id: 158, type: 'Audio / Sound Transfers' },
  // { child: { services: [], subtypes: [] }, id: 159, type: 'Cameras & Camera Equipment Rental' },
  // {
  //   child: { services: [], subtypes: [] },
  //   id: 160,
  //   type: 'Digital Asset Management (DAM) Services',
  // },
  // { child: { services: [], subtypes: [] }, id: 161, type: 'Digital Effects' },
  // { child: { services: [], subtypes: [] }, id: 162, type: 'Aerial Camera Systems' },
  // { child: { services: [], subtypes: [] }, id: 163, type: 'Action Vehicles' },
  // { child: { services: [], subtypes: [] }, id: 164, type: 'Camera & Grip Equipment' },
  // { child: { services: [], subtypes: [] }, id: 165, type: 'Accountancy Services' },
  // { child: { services: [], subtypes: [] }, id: 166, type: 'Talent Agencies' },
  // { child: { services: [], subtypes: [] }, id: 167, type: 'Stunt Services' },
  // { child: { services: [], subtypes: [] }, id: 168, type: 'Hospitality & Logistics' },
  // { child: { services: [], subtypes: [] }, id: 169, type: 'Video & Recording Equipment' },
  // { child: { services: [], subtypes: [] }, id: 170, type: 'Processing Laboratories' },
  // { child: { services: [], subtypes: [] }, id: 171, type: 'Book Publisher' },
  // { child: { services: [], subtypes: [] }, id: 172, type: '24 Frame Video Playback' },
  // { child: { services: [], subtypes: [] }, id: 173, type: 'Audio Visual (AV) Equipment' },
  // { child: { services: [], subtypes: [] }, id: 174, type: 'Crowd Casting' },
  // { child: { services: [], subtypes: [] }, id: 175, type: 'Quality Assurance Services' },
  // { child: { services: [], subtypes: [] }, id: 176, type: 'Special Effects' },
  // { child: { services: [], subtypes: [] }, id: 177, type: 'Audio - Voiceover / Narration' },
  // { child: { services: [], subtypes: [] }, id: 178, type: 'Music Recording' },
  // { child: { services: [], subtypes: [] }, id: 179, type: 'Aerial Photography' },
  // { child: { services: [], subtypes: [] }, id: 180, type: 'Camera Cars, Cranes & Dollies' },
  // { child: { services: [], subtypes: [] }, id: 181, type: 'Sound Studio' },
  // { child: { services: [], subtypes: [] }, id: 182, type: 'Animation/Computer Graphics (CGI)' },
  // { child: { services: [], subtypes: [] }, id: 183, type: 'Military, Firearms, Weapons Props' },
  // { child: { services: [], subtypes: [] }, id: 184, type: 'Mixing Recording Studio' },
  // { child: { services: [], subtypes: [] }, id: 185, type: 'Music Scoring / Film Score' },
  // { child: { services: [], subtypes: [] }, id: 186, type: 'Dialogue Editing' },
  // { child: { services: [], subtypes: [] }, id: 187, type: 'Traffic Management Services' },
  // { child: { services: [], subtypes: [] }, id: 188, type: 'Scriptwriting Services' },
  // { child: { services: [], subtypes: [] }, id: 189, type: 'Underwater Camera Operators' },
  // { child: { services: [], subtypes: [] }, id: 190, type: 'Digital Marketing' },
  // { child: { services: [], subtypes: [] }, id: 191, type: 'Vintage Camera Rental' },
  // { child: { services: [], subtypes: [] }, id: 192, type: 'Set Design & Construction' },
  // { child: { services: [], subtypes: [] }, id: 193, type: 'Archive & Restoration Services' },
  // { child: { services: [], subtypes: [] }, id: 194, type: 'Aerial Cinematography' },
  // { child: { services: [], subtypes: [] }, id: 195, type: 'DI (Digital Intermediate)' },
  // { child: { services: [], subtypes: [] }, id: 196, type: 'Colorists / Colour Graders' },
].sort((x, y) => x.type.localeCompare(y.type));

export default companyTypesMaster;
